<template>
  <ida-survey-quiz
    v-if="answerLists"
    :color="survey.color"
    :btnColor="survey.color"
    :answerLists="answerLists"
    :questions="questions"
    :userAnswers="userVotes"
    :locale="survey.locale"
    :duration="duration"
    @duration="handleDuration"
    @click="handleClick">
    <template slot="title">{{ title }}</template>
  </ida-survey-quiz>
</template>

<script>
import { mapGetters } from 'vuex'
import styles from '@/assets/styles/styles.scss'

export default {
  name: 'iDalgo-Survey-Quiz',
  data () {
    return {
      styles
    }
  },
  computed: {
    ...mapGetters({
      survey: 'survey/survey',
      hasVoted: 'survey/hasVoted',
      answerLists: 'survey/answerLists',
      questions: 'survey/questions',
      userVotes: 'survey/userVotes',
      duration: 'survey/duration'
    }),
    title () { return this.survey.title || this.$t('survey.title') },
    validateText () { return !this.hasVoted ? this.$t('actions.validate') : false },
    rightAnswerText () {
      return this.$tc('rightAnswer', 1)
    },
    wrongAnswerText () {
      return this.$tc('wrongAnswer', 1)
    },
    showAnswersText () {
      return this.$tc('showAnswers', this.hasVoted)
    }
  },
  methods: {
    handleClick (data) {
      // Data is array of keys
      this.$emit('click', data)
    },
    handleDuration (timeInSeconds) {
      this.$store.commit('survey/DURATION_UPDATED', timeInSeconds)
    }
  },
  mounted () {
    try {
      const duration = localStorage[`iDalgoSurvey-${this.$store.getters['survey/surveyId']}-duration`]
      if (duration) {
        this.$store.commit('survey/DURATION_UPDATED', duration || undefined)
      }
    } catch (e) {}
  }
}
</script>
